module.exports = __webpack_public_path__ + "static/im-bed05fde498a6a74bc21d2abfbfc33b4.svg";